module.exports = __webpack_public_path__ + "img/DIO2000_1-1.96ce9d4f.png";